module.exports = __webpack_public_path__ + "static/media/ankama.89ef066d.png";